<template>
  <el-card>
    <el-form
      :model="ruleForm"
      label-width="100px"
      :rules="rules"
      ref="ruleForm"
    >
      <el-row>
        <el-col :span="24"
          ><div class="grid-content">
            <el-form-item label="模板名称" prop="templateName">
              <el-input
                type="text"
                placeholder="请输入模板名称"
                v-model="ruleForm.templateName"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="24"
          ><div class="grid-content">
            <el-form-item label="主诉" prop="actionInChief">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入主诉"
                v-model="ruleForm.actionInChief"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="24"
          ><div class="grid-content">
            <el-form-item label="现病史" prop="historyPresentIllness">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入现病史"
                v-model="ruleForm.historyPresentIllness"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="24"
          ><div class="grid-content">
            <el-form-item label="过敏史" prop="drugAllergyHistory">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入过敏史"
                v-model="ruleForm.drugAllergyHistory"
              >
              </el-input>
            </el-form-item></div
        ></el-col> -->
        <el-col :span="24"
          ><div class="grid-content">
            <el-form-item label="辅助检查结果" prop="auxiliaryExamination">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入辅助检查结果"
                v-model="ruleForm.auxiliaryExamination"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-form-item style="text-align: center" v-show="showButton">
        <el-button type="primary" @click="submitForm()">保存</el-button>
        <el-button style="margin-left: 30px" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      ruleForm: {
        auxiliaryExamination: "",
        historyPresentIllness: "",
        actionInChief: "",
        drugAllergyHistory: "",
        templateName: "",
      },
      showButton: true,
      rules: {
        templateName: [
          {
            required: true, //是否必填
            message: "模板名称不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        actionInChief: [
          {
            required: true, //是否必填
            message: "主诉不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        historyPresentIllness: [
          {
            required: true, //是否必填
            message: "现病史不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        // drugAllergyHistory: [
        //   {
        //     required: true, //是否必填
        //     message: "过敏史不能为空", //规则
        //     trigger: "blur", //何事件触发
        //   },
        // ],
        auxiliaryExamination: [
          {
            required: true, //是否必填
            message: "辅助检查结果不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.detail) {
      this.showButton = false;
      this.init();
    }
    if (this.$route.query.id) {
      this.init();
    }
  },
  methods: {
    async init() {
      let that = this;
      const options = {
        templateId: this.$route.query.id,
        token: localStorage.getItem("token"),
      };
      let { code, obj } = await this.$http(
        "smarthos.user.book.case.history.template.info",
        options
      );
      if (code == "0") {
        that.ruleForm = obj;
      }
    },
    submitForm() {
      let that = this;
      that.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let obj = {};
          // obj.drugAllergyHistory = that.ruleForm.drugAllergyHistory;
          obj.actionInChief = that.ruleForm.actionInChief;
          obj.historyPresentIllness = that.ruleForm.historyPresentIllness;
          obj.auxiliaryExamination = that.ruleForm.auxiliaryExamination;
          obj.docId = JSON.parse(sessionStorage.getItem("loginInfo")).doc.id;
          obj.token = localStorage.getItem("token");
          obj.templateName=that.ruleForm.templateName;
          if (that.$route.query.id) {
            obj.service = "smarthos.user.book.case.history.template.update";
            obj.templateId = that.$route.query.id;
          } else {
            obj.service = "smarthos.user.book.case.history.template.save";
          }
          axiosUtil(obj, ({ code, list, msg }) => {
            if (code == "0") {
              that.$message.success("保存成功");
              that.$router.push({
                path: "/main/medicalTemplateList",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      this.$router.push({
        path: "/main/medicalTemplateList",
        // query: { id: item.visitid },
      });
    },
  },
};
</script>
<style scoped>
</style>